<template>
	<div class="wrapper">
		<sub-ibox-title :is-show-back=true>
			<p slot="title">{{params.id ? '编辑门店':'新增门店'}}</p>
		</sub-ibox-title>
		<section class="content">
			<div class="detail-cont">
				<div class="fx fx-y-center">
					<p class="title fx w120 m-r-5"><i class="ask">*</i><span class="fx-fill">门店logo</span></p>
					<!--<z-up-file :listArr="picList"></z-up-file>-->
					<z-upload :file-url='params.logo_url' :on-success="handleUploadSuccess"></z-upload>
					<div class="pic-tips m-l-10">建议尺寸：200*200</div>
				</div>
				<z-input maxlength=20 title="门店名称" class="m-t-15" v-model.trim="params.name" isMust=true></z-input>
				<z-input type="email" maxlength=11 title="手机号" class="m-t-15" v-model.trim="params.tel" isMust=true></z-input>
				<z-input title="门店位置-经度" class="m-t-15" v-model.trim="params.longitude" placeholder="如：103.4664916992" isMust=true></z-input>
				<z-input title="门店位置-纬度" class="m-t-15" v-model.trim="params.latitude" placeholder="如：39.3911013341" isMust=true></z-input>
				<div class="p-10 c-g fx shop-tips">
					<p class="w120 m-r-5"></p>
					<div>
						Tips：经度是大于纬度的哟！经纬度获取地址：
						<a href="http://www.gpsspg.com/maps.htm" class="link-style" target="_blank">http://www.gpsspg.com/maps.htm</a>
					</div>
				</div>
				<z-input title="门店地址" class="m-t-15" v-model.trim="params.address" isMust=true></z-input>
				<z-input title="语音设备编号" class="m-t-15" v-model.trim="params.device_name"></z-input>
			</div>
			<div class="m-t-20 fx btn-adaption">
				<p class="w120 m-r-5 fx-shrink"></p>
				<a class="z-btn z-btn-primary b-r-3" @click="handleAddBtn">保存</a>
			</div>
		</section>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'

	export default {
		name: 'ShopEdit',
		components: {},
		data() {
			return {
				params: {
					id: null, //店铺ID
					name: null, // 导航标题
					tel: null, //店铺名称
					logo_url: null, // 店铺位置
					latitude: null, //纬度
					longitude: null, //经度,
					address: null,//地址
					device_name:null //语音设备编号
				},
				picList: []
			}
		},
		mounted() {
			const id = this.$route.query.shopId
			if(this.$re_Number(id)) this.handleGetShopInfo(id)
		},
		/*
		 * 属性计算
		 */
		computed: {},
		/*
		 * 事件处理
		 */
		methods: {
			handleUploadSuccess(url){
				this.params.logo_url = url;
			},
			//保存
			async handleAddBtn() {
				if(!this.params.logo_url) return this.$warning('请上传封面( ･´ω`･ )');
				if(!this.params.name) return this.$warning('请填写门店名称( ･´ω`･ )');
				if(!this.$re_phone(this.params.tel)) return this.$warning('联系方式输入不正确 ( ･´ω`･ )');
				if(!this.$re_longitude(this.params.longitude)) return this.$warning('请输入正确经度( ･´ω`･ )');
				if(!this.$re_latitude(this.params.latitude)) return this.$warning('请输入正确纬度( ･´ω`･ )');
				if(!this.params.address) return this.$warning('请填写门店地址( ･´ω`･ )');
				try{
					await this.saveShopInfo(this.params);
					this.$success('操作成功');
					this.$back();
				}catch(e){
					this.$warning(e);
				}
			},
			
			//获取门店信息
			async handleGetShopInfo(id) {
				try{
					this.params = await this.getShopInfo({id})
				}catch(e){
					this.$errorMsg(e)
				}
			},
			...mapActions(['getShopInfo', 'saveShopInfo']),
		}
	}
</script>
<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	#content {
		min-height: px-em(400px);
	}
	
	.c-g {
		color: $color-font-sub;
	}
	
	.content {
		border-top: none;
	}
	
	.detail-cont {
		width: 600px;
	}
	
	.question-api {
		position: relative;
		width: px-em(120px);
		height: px-em(120px);
		border: 1px solid $color-border;
		border-radius: px-em(4px);
		overflow: hidden;
		&:hover {
			.edit {
				opacity: 1;
			}
		}
		input {
			display: inline-block;
			width: px-em(120px);
			height: px-em(120px);
			opacity: 0;
			position: relative;
			z-index: 99;
			cursor: pointer;
		}
		img {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
		}
		.edit {
			opacity: 0;
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.3);
			transition: all 0.2s ease;
			.icon {
				transition: all 0.2s ease;
				color: #fff;
				font-size: px-em(32px);
			}
		}
	}
	
	.file-btn {
		position: relative;
		width: px-em(200px);
		height: px-em(50px);
		overflow: hidden;
		cursor: pointer;
		&:hover {
			a {
				opacity: 0.8;
			}
		}
		a {
			position: absolute;
			width: 100%;
			height: 100%;
			z-index: 0;
		}
		input {
			position: absolute;
			display: block;
			opacity: 0;
			z-index: 1;
			width: 100%;
			height: 100%;
			cursor: pointer;
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.detail-cont{
			width: 100%;
		}
		.shop-tips{
			display: block;
		}
	}
</style>


// WEBPACK FOOTER //
// ShopEdit.vue?2e51c5c2